import { render } from "./DurationContent.vue?vue&type=template&id=23d7f51a&scoped=true&ts=true"
import script from "./DurationContent.vue?vue&type=script&lang=ts"
export * from "./DurationContent.vue?vue&type=script&lang=ts"

import "./DurationContent.vue?vue&type=style&index=0&id=23d7f51a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23d7f51a"]])

export default __exports__